import { Module } from '../../utils';
import sagas from './sagas';

export default new Module({
  sagas
});

export * from './components';
export * from './sagas';